import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-10d534c6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "holder" }
const _hoisted_2 = {
  key: 0,
  class: "headers"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "title" }, "Aekos Trading", -1))
const _hoisted_4 = {
  key: 0,
  class: "subtitle"
}
const _hoisted_5 = { key: 2 }
const _hoisted_6 = {
  key: 1,
  class: "form-holder"
}
const _hoisted_7 = { class: "form-top-bar" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "form-title" }, "Contact Us", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Subject", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Your email", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Message", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.formVisible)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _hoisted_3,
          (!_ctx.formSent)
            ? (_openBlock(), _createElementBlock("p", _hoisted_4, " Developing the next generation of trading algorithms. "))
            : _createCommentVNode("", true),
          (!_ctx.formVisible && !_ctx.formSent)
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.formVisible = !_ctx.formVisible)),
                class: "button"
              }, " Contact Us "))
            : _createCommentVNode("", true),
          (_ctx.formSent)
            ? (_openBlock(), _createElementBlock("p", _hoisted_5, " Thank you for your interest, we will be in touch soon. "))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_ctx.formVisible)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _createElementVNode("button", {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.formVisible = !_ctx.formVisible)),
              class: "button close-button"
            }, " Close ")
          ]),
          _hoisted_9,
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.title) = $event))
          }, null, 512), [
            [_vModelText, _ctx.title]
          ]),
          _hoisted_10,
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.email) = $event))
          }, null, 512), [
            [_vModelText, _ctx.email]
          ]),
          _hoisted_11,
          _withDirectives(_createElementVNode("textarea", {
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.message) = $event))
          }, null, 512), [
            [_vModelText, _ctx.message]
          ]),
          _createElementVNode("button", {
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.sendForm())),
            class: "button send-button"
          }, "Send")
        ]))
      : _createCommentVNode("", true)
  ]))
}